/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2021-10-13 10:48:36
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\iWoResource\iWoResource.js
 * @Description: 
 */
'use strict';
angular.module('iWoResourceModule', [
    'iWoShareInventoryRouterModule',
    'iWoShareInventoryModule',
    'iWoManuscriptCollectionRouterModule',
    'iWoManuscriptCollectionModule',
    // 'editIWoPersonalMaterialRouterModule',
    // 'editIWoPersonalMaterialModule',
    'editIWoResourceCustomRouterModule',
    'editIWoResourceCustomModule',
    'editingCenterSharedMailModule'
]).controller('iWoResourceCtrl', ['$scope', function($scope) {
}]);
